import type { IApplication } from '../types';
import { getFonts, getWebGLInfo } from '../fingerprint';

export function getApplicationInfo(gdpr = false): IApplication {
  const webGLInfo = getWebGLInfo();
  return {
    ea: webGLInfo?.VENDOR ?? '',
    eb: webGLInfo?.RENDERER ?? '',
    ec: gdpr ? [...navigator.plugins].map(item => item.name).join(',') : '',
    ed: [...navigator.mimeTypes].map(item => item.type).join(','),
    ee: gdpr ? getFonts() : '',
    ef: webGLInfo?.VERSION ?? '',
    eg: webGLInfo?.SHADING_LANGUAGE_VERSION ?? '',
  }
}
